"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TableauSheetEvent_1 = require("./TableauSheetEvent");
class TableauWorksheetEvent extends TableauSheetEvent_1.TableauSheetEvent {
    constructor(type, _worksheet) {
        super(type, _worksheet);
        this._worksheet = _worksheet;
    }
    get worksheet() {
        return this._worksheet;
    }
}
exports.TableauWorksheetEvent = TableauWorksheetEvent;
//# sourceMappingURL=TableauWorksheetEvent.js.map